import React from 'react';
import dayjs from 'dayjs';
import { Box, Chip, Divider, Typography } from '@mui/material';

const getStatusColor = (status) => {
  switch (status) {
    case 'sent':
      return 'success';
    case 'failed':
      return 'error';
    case 'draft':
    default:
      return 'default';
  }
};

const DetailRow = ({ label, value }) => {
  if (!value) return null;

  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" color="text.primary">
        {value}
      </Typography>
    </Box>
  );
};

const EmailMessageDetail = ({ selectedValues }) => {
  if (!selectedValues?.id) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Válassz ki egy e-mailt a listából.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, height: '100%', overflow: 'auto' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
        <Typography variant="h6">{selectedValues.subject || 'Tárgy nélkül'}</Typography>
        <Chip
          label={selectedValues.status ?? 'ismeretlen'}
          color={getStatusColor(selectedValues.status)}
          size="small"
        />
      </Box>

      <DetailRow
        label="Küldés ideje"
        value={selectedValues.sentDate ? dayjs(selectedValues.sentDate).format('YYYY.MM.DD. HH:mm') : ''}
      />
      <DetailRow label="Feladó" value={selectedValues.emailFrom} />
      <DetailRow label="Címzett" value={selectedValues.emailTo} />
      <DetailRow label="Másolat" value={selectedValues.emailCc} />
      <DetailRow label="Titkos másolat" value={selectedValues.emailBcc} />
      <DetailRow label="Válaszcím" value={selectedValues.replyTo} />
      <DetailRow label="Bizonylattípus" value={selectedValues.documentType?.name} />
      <DetailRow label="Form" value={selectedValues.form?.subMenuName} />
      <DetailRow label="Küldő felhasználó" value={selectedValues.user?.userName} />

      {selectedValues.errorMessage && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" color="error">
            Hibaüzenet
          </Typography>
          <Typography variant="body2" color="error">
            {selectedValues.errorMessage}
          </Typography>
        </Box>
      )}

      <Divider sx={{ my: 2 }} />

      <Typography variant="caption" color="text.secondary">
        Szöveg
      </Typography>
      <Box
        sx={{
          mt: 1,
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'background.paper',
          minHeight: 220,
        }}
        dangerouslySetInnerHTML={{ __html: selectedValues.body ?? '' }}
      />

      <Divider sx={{ my: 2 }} />

      <Typography variant="caption" color="text.secondary">
        Csatolmányok
      </Typography>
      <Box sx={{ mt: 1, display: 'grid', gap: 1 }}>
        {(selectedValues.emailMessageAttachment ?? []).length > 0 ? (
          selectedValues.emailMessageAttachment.map((attachment) => (
            <Box
              key={attachment.id ?? attachment.path}
              sx={{
                p: 1.5,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                backgroundColor: 'background.paper',
              }}
            >
              <Typography variant="body2">{attachment.name}</Typography>
              <Typography variant="caption" color="text.secondary">
                {attachment.contentType} • {attachment.sourceType}
              </Typography>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            Nincs csatolmány.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default EmailMessageDetail;
